import { TranslateService } from "../i18n/translate.service";
import { A3MM, BasePDFNode, RectPDFNode, TextPDFNode} from "./BasePDFNode";
import jsPDF from "jspdf";

export class PageCardNode extends RectPDFNode {
    public constructor(pdf: jsPDF, public translateService: TranslateService, public klantNo: string, public klantNaam: string) {
        super(pdf, {
            flexDirection: 'row',
            // borderColor: '#E00000',
            alignItems: 'flex-end',
            justifyContent: 'flex-end',
            margin: 2,

        });
    }

    public init(): void {
        let repo = this.translateService.translateSignal();
        let klantNoTxt = this.translateService.getTranslationSync(repo, 'pdf', 'KlantNo {klantNo}', 'KlantNo {klantNo}', { klantNo: this.klantNo });
        let klantNaamTxt = this.translateService.getTranslationSync(repo, 'pdf', 'KlantNaam {klantNaam}', 'KlantNaam {klantNaam}', { klantNaam: this.klantNaam });
        this.addChild2(new RectPDFNode(this.pdf, {
            borderColor: '#000000',
            padding:1 
        })).addChild2(new TextPDFNode(this.pdf, {
            fontSize: 10,
            width: 40
        })).text = klantNoTxt;
        this.addChild2(new RectPDFNode(this.pdf, {
            borderColor: '#000000',
            padding:1 
        })).addChild2(new TextPDFNode(this.pdf, {
            fontSize: 10,
            
            width: 100
        })).text = klantNaamTxt;
        super.init();
    }

    public render(): void {
        this.layout.calculateLayout(A3MM.width, A3MM.height);
        super.render();
    }
}